// @ts-nocheck
import React from 'react';

import Ref from 'models/propTypes/ref';
import { useFocusManager } from 'hooks/focus';

function FocusManagerHOC(Component) {
  const FocusManagerWrapper = ({ forwardedRef, ...props }) => {
    const focusManager = useFocusManager();
    return (
      <Component focusManager={focusManager} {...props} ref={forwardedRef} />
    );
  };

  FocusManagerWrapper.propTypes = {
    forwardedRef: Ref,
  };

  FocusManagerWrapper.defaultProps = {
    forwardedRef: null,
  };

  return React.forwardRef((props, ref) => (
    <FocusManagerWrapper {...props} forwardedRef={ref} />
  ));
}

export default FocusManagerHOC;
